<template>
    <BCard v-if="classroom"> 
        <BRow>
            <BCol cols="12" xl="4">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="classroom.name" />
                </table>
            </BCol>
            <BCol cols="12" xl="4">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="HomeIcon" vsLabel="Group" :vsValue="classroom.group ? classroom.group.name : '' " />
                </table>
            </BCol>
            <BCol cols="12" xl="4">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Plazas" :vsValue="classroom.places " />
                </table>
            </BCol>
            <BCol cols="12" class="mt-2" v-if="classroom.observations">
                <div class="col-12 mb-1 title p-0 font-weight-bold">
                    <FeatherIcon icon="InfoIcon" class="mr-75" />
                    <span>{{ $t('Observations') }}</span>
                </div>
                <div class="col-12 p-0"> {{ classroom.observations }} </div>
            </BCol>
            <BCol cols="12" class="pt-3">
                <div class="d-flex flex-wrap">
                    <BButton :to="{ name: 'classrooms-edit', params: { id: classroom.id } }" variant="primary" v-if="ability.can('write', 'classroom')"> {{$t('Edit')}} </BButton>
                    <BButton variant="outline-danger" class="ml-1" @click="deletePopup(classroom.id, 'classrooms/deleteClassroom', 'classrooms')" v-if="ability.can('delete', 'classroom')"> {{$t('Delete')}} </BButton>
                </div>
            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { BRow, BCard, BCol, BButton, BLink } from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import ViewData from '@/components/ViewData.vue'
import classroomModule from '../classroomModule'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import router from '@/router'
import store from '@/store'

export default {
    components: { BRow, BCol, BCard, BButton, BLink, ViewData },
    setup(){
        const { deletePopup } = popups();
        const CLASSROOM_MODULE = 'classrooms'
        const classroom = ref(null)

        if (!store.hasModule(CLASSROOM_MODULE)) store.registerModule(CLASSROOM_MODULE, classroomModule)

        onUnmounted(() => {
            if(store.hasModule(CLASSROOM_MODULE)) store.unregisterModule(CLASSROOM_MODULE)
        })

        store.dispatch('classrooms/fetchClassroom', { id: router.currentRoute.params.id }).then(response => {
            classroom.value = response.data.classroom
        })


        return {
            deletePopup,
            ability,
            classroom,
        }
    }
  }
</script>

<style lang="scss">
    @import 'src/assets/scss/variables/_variables.scss';
    table tr th, .title {
        color: $primary;
    }

    table tr th span, .title {
        text-transform: uppercase;
    }
</style>
